import { Container, Grid, createTheme, useMediaQuery } from '@mui/material'
import { signMessage } from '@wagmi/core'
import { useEffect } from 'react'
import {
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import { useAccount, useConnections } from 'wagmi'
import './App.css'
import { MobileTabWrapper } from './Layout'
import { Footer, NavBar, NavBarMobile, apiLinks, config } from './components'
import InputForm from './components/token-details/InputForm'
import InputFormStats from './components/token-details/InputFormStats'
import { Network } from './contracts'
import useGlobalStore from './stores/global'
import { constructTheme } from './themes'
import { Dashboard, Market, Rewards } from './views'
import TokenDetails from './views/TokenDetails'

function App() {

  const themeMode = useGlobalStore((state) => state.theme)
  const seedStore = useGlobalStore((state) => state.seedStore)
  const setUserAddress = useGlobalStore((state) => state.setUserAddress)
  const setNetwork = useGlobalStore((state) => state.setNetwork)
  const getReferrer = useGlobalStore((state) => state.getReferrer)
  // const setReferrer = useGlobalStore((state) => state.setReferrer)
  const network = useGlobalStore(state => state.network)
  const theme = createTheme(constructTheme(themeMode))
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isSmallerScreen = useMediaQuery(theme.breakpoints.down('lg'))
  const { address, isConnected, chainId } = useAccount();

  //Check for referral
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const referrer = urlParams.get('referrer')
  const useConnectFromWagmi = useConnections()

  useEffect(() => {
    if (!referrer || !address || !useConnectFromWagmi?.length) return
    const signReferralMsg = async () => {
      const refInfo = await getReferrer()
      const { referredBy } = refInfo?.meta
      if (referredBy) return urlParams.delete('referrer')
      try {
        const message = `Using referral code: ${referrer}`
        const signature = await signMessage(config, { account: address, message })
        await fetch(`${apiLinks[network]}/user/refer`, {
          method: "POST",
          body: JSON.stringify({
            user: address,
            signature: signature,
            referralCode: referrer
          }),
          headers: {
            "Content-type": "application/json; charset=UTF-8"
          }
        })
      }
      catch (e) { console.log(e) }
    }
    signReferralMsg()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, referrer, useConnectFromWagmi])

  const NavBarComponent = isMobile ? NavBarMobile : NavBar

  useEffect(() => {
    setUserAddress(isConnected ? address : undefined)
    if (isConnected && address) seedStore() //reseed store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address])

  useEffect(() => {
    if (!chainId || useConnectFromWagmi?.length) return
    if (chainId === 47763) setNetwork('mainnet' as Network)
    else setNetwork('testnet' as Network)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId])


  const TokenDetailsView = isSmallerScreen ?
    <MobileTabWrapper
      enableNav={true}
      tabs={[<TokenDetails />, <Grid container gap={2}><InputForm /><InputFormStats /></Grid>]}
      tabsName={['Overview', 'My Position']}
    /> : <TokenDetails />

  return (

    <ThemeProvider theme={theme}>
      <Router>
        <div className="background-layer" />
        <div className={`App App-${themeMode}`}>
          <NavBarComponent />
          <Container style={{ maxWidth: 1400 }}>
            <Routes>
              <Route path="/rewards" element={<Rewards />} />
              <Route path="/token/:denom" element={TokenDetailsView} />
              <Route path="/portfolio" element={<Dashboard />} />
              <Route path="*" element={<Market />} />
            </Routes>
          </Container>
          <Footer />
        </div>
      </Router>
    </ThemeProvider >
  )
}

export default App
